import { render, staticRenderFns } from "./applyReturnGoods.vue?vue&type=template&id=6ae20b7e&scoped=true"
import script from "./applyReturnGoods.vue?vue&type=script&lang=js"
export * from "./applyReturnGoods.vue?vue&type=script&lang=js"
import style0 from "./applyReturnGoods.vue?vue&type=style&index=0&id=6ae20b7e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae20b7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae20b7e')) {
      api.createRecord('6ae20b7e', component.options)
    } else {
      api.reload('6ae20b7e', component.options)
    }
    module.hot.accept("./applyReturnGoods.vue?vue&type=template&id=6ae20b7e&scoped=true", function () {
      api.rerender('6ae20b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/applyReturnGoods/applyReturnGoods.vue"
export default component.exports